import { TFunction } from "react-i18next";
import { ResponseUserAccess } from "../response"

const formatUserAccessResponse = ({ response, t }: { response: ResponseUserAccess, t: TFunction<"translation", undefined> }) => {

    const row = !response.errors
        ? response?.map((item) => {

            return {
                userId: item?.userId,
                accessWeb: item?.accessWeb == 1 ? true : false,
                accessMobile: item?.accessMobile == 1 ? true : false,
                accessShowReport: item?.accessShowReport == 1 ? true : false,
                accessResendReport: item?.accessResendReport == 1 ? true : false,
                firstName: item?.firstName,
                lastName: item?.lastName,
                curp: item?.curp,
                fullName: item?.fullName,
                area:item?.area,
                department: item?.department
            }
        })
        : []

    return {
        row
    }
}

export { formatUserAccessResponse }